(function () {
  window.MWCWatchDetailConstants = {
    selectors: {
      root: "#mwc-watch-detail",
      template: "#mwc-watch-detail-template",
      recommendations: "[data-mwc-recommendations]",
      recommendationText: "[data-mwc-recommendation-text]",
      recommendationProducts: "[data-mwc-recommendation-products]"
    },

    routes: {
      myWatches: "/pages/my-watches",
      productJson: function (handle) {
        return "/products/" + encodeURIComponent(handle) + ".js";
      }
    },

    defaults: {
      shop: "NL",
      recommendationFallbackTitle: "Aanbevolen straps voor dit horloge"
    }
  };
})();